module.exports = __webpack_public_path__ + "img/expectation.425ddff4.png";